import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import PendenciasFinanceiras from "../../common/query/PendenciasFinanceiras";
import Protestos from "../../common/query/Protestos";
import ChequesSemFundos from "../../common/query/ChequesSemFundos";
import ParticipacaoEmEmpresas from "../../common/query/ParticipacaoEmEmpresas";
import QuadroSocietario from "../../common/query/QuadroSocietario";
import Enderecos from "../../common/query/Enderecos";
import HistoricoConsultas from "../../common/query/HistoricoConsultas";
import Telefones from "../../common/query/Telefones";
import {
  countScore,
  formatDocument,
  formatToReal,
  getColorScore,
  getImageURLScoreSerasa,
} from "../../../utils/utils";
import { Table } from "flowbite-react";

const SerasaAvancadoPF = ({ data, dataFull }) => {
  const formatValue = (value) => {
    if (value == null || value === "") return "Indisponível";
    if (typeof value === "object") {
      if (Array.isArray(value)) return value.join(", ");
      return JSON.stringify(value);
    }
    return value;
  };

  const buildAddress = () =>
    [
      data?.dadosCadastrais?.endereco,
      data?.dadosCadastrais?.bairro,
      data?.dadosCadastrais?.cidade,
      data?.dadosCadastrais?.uf,
      data?.dadosCadastrais?.cep,
    ]
      .filter(Boolean)
      .join(", ");

  const hasCnpj = Boolean(data?.dadosCadastrais?.cnpj);

  const renderGenericList = (items = []) => {
    if (!items?.length) return <NoOcurrence />;
    return items.map((item, index) => (
      <div
        key={`generic-${index}`}
        className="bg-white border border-gray-200 rounded-2xl p-4 mb-3"
      >
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {Object.entries(item).map(([key, value]) => (
            <div key={key}>
              <p className="text-gray-400 text-2xs uppercase tracking-wide mb-1">
                {key}
              </p>
              <p className="text-sm font-medium text-gray-800">
                {formatValue(value)}
              </p>
            </div>
          ))}
        </div>
      </div>
    ));
  };

  const companyFields = [
    {
      label: "Razão Social",
      value: data?.dadosCadastrais?.razaoSocial,
    },
    {
      label: "Nome Fantasia",
      value: data?.dadosCadastrais?.nomeFantasia,
    },
    {
      label: "CNPJ",
      value: formatDocument(data?.dadosCadastrais?.cnpj),
    },
    {
      label: "Situação cadastral",
      value:
        data?.dadosCadastrais?.situacaoCadastral ||
        data?.dadosCadastrais?.situacao,
    },
    {
      label: "Data de situação cadastral",
      value: data?.dadosCadastrais?.dataSituacaoCadastral,
    },
    {
      label: "Fundação",
      value: data?.dadosCadastrais?.dataFundacao,
    },
    {
      label: "Início de atividade",
      value: data?.dadosCadastrais?.dataInicioAtividade,
    },
    {
      label: "Município",
      value: data?.dadosCadastrais?.municipio,
    },
  ];

  return (
    <div className="space-y-4">
      {!hasCnpj && (
        <div>
          <TitleStripe badge="fonte II">Dados Cadastrais</TitleStripe>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 text-sm border border-gray-200 rounded-xl overflow-hidden mt-4">
            {[
              { label: "Nome completo", value: data?.dadosCadastrais?.nome },
              {
                label: "CPF",
                value: formatDocument(data?.dadosCadastrais?.cpf),
              },
              {
                label: "Situação CPF",
                value: data?.dadosCadastrais?.situacao,
                isStatus: true,
              },
              { label: "Nome da mãe", value: data?.dadosCadastrais?.nomeMae },
              {
                label: "Data de nascimento",
                value: data?.dadosCadastrais?.dataNascimento,
              },
              {
                label: "Sexo",
                value: data?.dadosCadastrais?.sexo,
              },
              {
                label: "RG",
                value: data?.dadosCadastrais?.numeroRG,
              },
              {
                label: "Endereço principal",
                value: buildAddress(),
              },
              {
                label: "Telefone principal",
                value: data?.dadosCadastrais?.telefone,
              },
            ].map((item) => (
              <div
                key={item.label}
                className="p-4 border-b border-gray-200 sm:border-b-0 sm:border-r"
              >
                <p className="text-gray-500 text-xs mb-1">{item.label}</p>
                {item.isStatus ? (
                  <span
                    className={`font-semibold text-sm px-2 py-0.5 rounded-md text-white inline-block ${
                      item.value?.toString()?.toUpperCase() === "REGULAR"
                        ? "bg-blue-800"
                        : "bg-red-500"
                    }`}
                  >
                    {formatValue(item.value)}
                  </span>
                ) : (
                  <p className="font-medium text-gray-800">
                    {formatValue(item.value)}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {hasCnpj && (
        <div className="mt-6">
          <TitleStripe className="mb-5" badge="fonte II">
            Dados Cadastrais
          </TitleStripe>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 text-sm border border-gray-200 rounded-xl overflow-hidden">
            {companyFields.map((item) => (
              <div
                key={item.label}
                className="p-4 border-b border-gray-200 sm:border-b-0 sm:border-r"
              >
                <p className="text-gray-500 text-xs mb-1">{item.label}</p>
                <p className="font-medium text-gray-800">
                  {formatValue(item.value)}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="mt-6">
        <TitleStripe className="mb-5" badge="fonte II">
          Score
        </TitleStripe>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex flex-col items-center justify-center border rounded-xl bg-white shadow-sm p-6">
            <img
              src={getImageURLScoreSerasa(data?.score?.score)}
              alt="Score"
              className="h-24"
            />
            <div
              className="font-bold text-base text-white mt-4 px-6 py-2 rounded-full shadow"
              style={{ backgroundColor: getColorScore(data?.score?.score) }}
            >
              Score {data?.score?.score ?? "Não disponível"}
            </div>
          </div>
          <div className="flex flex-col justify-between border border-gray-200 rounded-xl bg-gray-50 p-6 shadow-sm">
            <div>
              <p className="font-medium text-gray-700">
                Probabilidade de inadimplência
              </p>
              <p className="text-4xl font-black text-red-600 mt-1">
                {data?.score?.probabilidadeInadimplencia != null
                  ? `${data?.score?.probabilidadeInadimplencia}%`
                  : "N/A"}
              </p>
            </div>
            {data?.attributes?.length > 0 && (
              <div className="mt-4 text-sm text-gray-600 space-y-1">
                <p className="font-semibold text-gray-800">
                  Atributos vinculados
                </p>
                {data.attributes.map((attribute, index) => (
                  <div key={`attr-${index}`}>
                    <p>{attribute?.attributeModel || attribute?.message}</p>
                    {attribute?.message && (
                      <p className="text-xs text-gray-500">
                        {attribute.message}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      {hasCnpj ? (
        <div>
          <TitleStripe className="mb-5" badge="fonte II">
            Quadro Societário
          </TitleStripe>
          {data?.socios?.length > 0 ? (
            <div className="overflow-x-hidden border-gray-300 border rounded-lg mt-3">
              <Table striped>
                <Table.Head className="text-black">
                  <Table.HeadCell
                    className="text-center py-2 px-1"
                    style={{ background: "#EBF5FF" }}
                  >
                    Nº
                  </Table.HeadCell>
                  <Table.HeadCell
                    className="py-2"
                    style={{ background: "#EBF5FF" }}
                  >
                    Nome
                  </Table.HeadCell>
                  <Table.HeadCell
                    className="py-2"
                    style={{ background: "#EBF5FF" }}
                  >
                    Documento
                  </Table.HeadCell>
                  <Table.HeadCell
                    className="text-center py-2 px-1"
                    style={{ background: "#EBF5FF" }}
                  >
                    Função
                  </Table.HeadCell>
                  <Table.HeadCell
                    className="text-center py-2 px-1"
                    style={{ background: "#EBF5FF" }}
                  >
                    Data Entrada
                  </Table.HeadCell>
                </Table.Head>
                {data?.socios?.length > 0 && (
                  <Table.Body className="divide-y">
                    {data?.socios?.map((socio, index) => (
                      <Table.Row
                        key={index}
                        className="bg-white dark:border-gray-700 dark:bg-gray-800 text-black"
                      >
                        <Table.Cell className="font-medium dark:text-white text-center py-2 px-1">
                          {index + 1}
                        </Table.Cell>
                        <Table.Cell className=" py-2">
                          <div>{socio?.empresa || "-"}</div>
                        </Table.Cell>
                        <Table.Cell className=" py-2">
                          {formatDocument(socio?.cnpj)}
                        </Table.Cell>
                        <Table.Cell className="text-center py-2 px-1">
                          {socio?.funcao}
                        </Table.Cell>
                        <Table.Cell className="text-center py-2 px-1">
                          {socio?.dataEntrada}
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                )}
              </Table>
            </div>
          ) : (
            <NoOcurrence />
          )}
        </div>
      ) : (
        <div className="mt-6">
          <TitleStripe className="mb-5" badge="fonte II">
            Participações e Sociedades
          </TitleStripe>
          {data?.participacaoEmEmpresas?.length > 0 ? (
            <>
              <ParticipacaoEmEmpresas empresas={data?.participacaoEmEmpresas} />
            </>
          ) : (
            <NoOcurrence />
          )}
        </div>
      )}

      {data?.telefones?.length > 0 && (
        <div className="mt-6">
          <TitleStripe className="mb-5" badge="fonte II">
            Telefones
          </TitleStripe>
          <Telefones telefones={data.telefones} />
        </div>
      )}

      {data?.enderecos?.length > 0 && (
        <div className="mt-6">
          <TitleStripe className="mb-5" badge="fonte II">
            Endereços
          </TitleStripe>
          <Enderecos enderecos={data?.enderecos} />
        </div>
      )}

      <div className="mt-6">
        <TitleStripe className="mb-5" badge="fonte II">
          Pendências Comerciais
        </TitleStripe>
        {data?.pefin?.length > 0 ? (
          <PendenciasFinanceiras
            quantidadeTotal={data?.resumoConsulta?.pefin?.quantidadeTotal}
            valorTotal={data?.resumoConsulta?.pefin?.valorTotal}
            pendenciasFinanceiras={data?.pefin}
          />
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div className="mt-6">
        <TitleStripe className="mb-5" badge="fonte II">
          Pendências com fornecedores
        </TitleStripe>
        {data?.refin?.length > 0 ? (
          <PendenciasFinanceiras
            quantidadeTotal={data?.resumoConsulta?.refin?.quantidadeTotal}
            valorTotal={data?.resumoConsulta?.refin?.valorTotal}
            pendenciasFinanceiras={data?.refin}
          />
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div className="mt-6">
        <TitleStripe className="mb-5" badge="fonte II">
          Dívidas Vencidas
        </TitleStripe>
        {data?.dividasVencidas?.length > 0 ? (
          <PendenciasFinanceiras
            quantidadeTotal={
              data?.resumoConsulta?.dividasVencidas?.quantidadeTotal
            }
            valorTotal={data?.resumoConsulta?.dividasVencidas?.valorTotal}
            pendenciasFinanceiras={data?.dividasVencidas}
          />
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div className="mt-6">
        <TitleStripe className="mb-5" badge="fonte II">
          Protestos
        </TitleStripe>
        {data?.protestos?.length > 0 ? (
          <Protestos
            quantidadeTotal={data?.resumoConsulta?.protestos?.quantidadeTotal}
            valorTotal={data?.resumoConsulta?.protestos?.valorTotal}
            protestos={data?.protestos}
            temVencimento={false}
          />
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div className="mt-6">
        <TitleStripe className="mb-5" badge="fonte II">
          Cheques sem fundos
        </TitleStripe>
        {data?.chequesSemFundo?.length > 0 ? (
          <ChequesSemFundos chequesSemFundos={data?.chequesSemFundo} />
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div className="mt-6">
        <TitleStripe className="mb-5" badge="fonte II">
          Ações Cíveis
        </TitleStripe>
        {data?.acoesCiveis?.length > 0 ? (
          <div className="rounded-2xl border border-gray-200 overflow-hidden">
            <div className="grid grid-cols-6 bg-blue-50 text-xs font-semibold uppercase text-gray-600 border-b border-gray-200">
              <div className="px-4 py-3">Data</div>
              <div className="px-4 py-3">Processo</div>
              <div className="px-4 py-3">Valor</div>
              <div className="px-4 py-3">Ação</div>
              <div className="px-4 py-3">Cidade</div>
              <div className="px-4 py-3">Autor</div>
            </div>
            {data?.acoesCiveis?.map((acao, index) => (
              <div
                key={`acao-${index}`}
                className={`grid grid-cols-6 text-sm text-gray-700 border-b last:border-b-0 ${
                  index % 2 === 0 ? "bg-white" : "bg-gray-50"
                }`}
              >
                <div className="px-4 py-3">{acao?.data || "-"}</div>
                <div className="px-4 py-3">{acao?.processo || "-"}</div>
                <div className="px-4 py-3">{formatToReal(acao?.valor)}</div>
                <div className="px-4 py-3">{acao?.acao || "-"}</div>
                <div className="px-4 py-3">
                  {acao?.cidade || acao?.estado || "-"}
                </div>
                <div className="px-4 py-3">{acao?.autor || "-"}</div>
              </div>
            ))}
          </div>
        ) : (
          <NoOcurrence />
        )}
      </div>

      {data?.dadosCadastrais?.cnpj && (
        <div className="mt-6">
          <TitleStripe className="mb-5" badge="fonte II">
            Falências / Recuperações Judiciais
          </TitleStripe>
          {renderGenericList(data?.falenciasRecJudiciais)}
        </div>
      )}

      <div className="mt-6">
        <TitleStripe className="mb-5" badge="fonte II">
          Histórico de Consultas
        </TitleStripe>
        {data?.historicoConsultas?.length > 0 ? (
          <HistoricoConsultas
            historicoConsultas={data?.historicoConsultas}
            quantidadeTotal={data?.historicoConsultas?.length}
          />
        ) : (
          <NoOcurrence />
        )}
      </div>
    </div>
  );
};

export default SerasaAvancadoPF;
